import React from 'react'
import { MoveSubCategoryModal } from './subcategory-modal'
import { MoveCategoryModal } from './category-modal'

const removeCategoryFromOldParent = (isGroupCategoryLevel, category, oldParentCategory, hierarchy) => {
  const newHierarchy = JSON.parse(JSON.stringify(hierarchy))

  for (let i = 0; i < newHierarchy.length; i++) {
    if (isGroupCategoryLevel) {
      if (newHierarchy[i].sk === oldParentCategory.sk) {
        newHierarchy[i].children = newHierarchy[i].children.filter(child => child.sk !== category.sk)
        break
      }
    } else if (newHierarchy[i].children) {
      for (let j = 0; j < newHierarchy[i].children.length; j++) {
        if (newHierarchy[i].children[j].sk === oldParentCategory.sk) {
          newHierarchy[i].children[j].children = newHierarchy[i].children[j].children.filter(child => child.sk !== category.sk)
          break
        }
      }
    }
  }

  return newHierarchy
}

const addCategoryToNewParent = (isGroupCategoryLevel, category, newParentCategorySK, hierarchy) => {
  const newHierarchy = JSON.parse(JSON.stringify(hierarchy))

  for (let i = 0; i < newHierarchy.length; i++) {
    if (isGroupCategoryLevel) {
      if (newHierarchy[i].sk === newParentCategorySK) {
        newHierarchy[i].children ? newHierarchy[i].children.push(category) : newHierarchy[i].children = [category]
        break
      }
    } else if (newHierarchy[i].children) {
      for (let j = 0; j < newHierarchy[i].children.length; j++) {
        if (newHierarchy[i].children[j].sk === newParentCategorySK) {
          newHierarchy[i].children[j].children
            ? newHierarchy[i].children[j].children.push(category)
            : newHierarchy[i].children[j].children = [category]
          break
        }
      }
    }
  }

  return newHierarchy
}

const isRootCategory = (category) => category.parentFriendlyUrl.indexOf('ROOT_') === 0

export function HandleCategoryMove ({
  data,
  newParentCategorySk,
  setNewParentCategorySk,
  newCategoryPosition,
  setNewCategoryPosition = () => {},
  onMove = () => {},
  open,
  onCancel = () => {}
}) {
  const handleMove = React.useCallback(() => {
    if (!data) return null
    const { category, parentCategory, hierarchy } = data
    const isGroupCategoryLevel = isRootCategory(parentCategory)

    let newHierarchy = removeCategoryFromOldParent(isGroupCategoryLevel, category, parentCategory, hierarchy)

    category.parentFriendlyUrl = newParentCategorySk
    category.parent = {
      ...category.parent,
      sk: newParentCategorySk
    }
    category.position = newCategoryPosition

    newHierarchy = addCategoryToNewParent(isGroupCategoryLevel, category, newParentCategorySk, newHierarchy)

    onMove(category, newHierarchy)
  }, [onMove, data, newCategoryPosition, newParentCategorySk])

  if (!data) return null
  const { category, parentCategory, hierarchy } = data
  const isGroupCategory = isRootCategory(parentCategory)

  const handleCategorySelection = (e) => {
    setNewParentCategorySk(e.target.value)
    const newParentChildren = hierarchy?.find(({ sk }) => sk === e.target.value)?.children

    let position
    if (newParentChildren && newParentChildren.length > 0) {
      position = newParentChildren[newParentChildren.length - 1]?.position + 1
    } else {
      position = 0
    }
    setNewCategoryPosition(position)
  }

  const handleSubCategorySelection = (selectedGroupCategory, selectedCategorySk) => {
    setNewParentCategorySk(selectedCategorySk)
    const newParentChildren = selectedGroupCategory?.children.find(({ sk }) => sk === selectedCategorySk)?.children

    let position
    if (newParentChildren && newParentChildren.length > 0) {
      position = newParentChildren[newParentChildren.length - 1]?.position + 1
    } else {
      position = 0
    }
    setNewCategoryPosition(position)
  }

  return isGroupCategory ? (
    <MoveCategoryModal
      category={category}
      parentCategory={parentCategory}
      hierarchy={hierarchy}
      handleMove={handleMove}
      handleCategorySelection={handleCategorySelection}
      newParentCategorySk={newParentCategorySk}
      setNewParentCategorySk={setNewParentCategorySk}
      open={open}
      onCancel={onCancel}
    />
  ) : (
    <MoveSubCategoryModal
      category={category}
      parentCategory={parentCategory}
      hierarchy={hierarchy}
      handleMove={handleMove}
      handleSubCategorySelection={handleSubCategorySelection}
      newParentCategorySk={newParentCategorySk}
      setNewParentCategorySk={setNewParentCategorySk}
      open={open}
      onCancel={onCancel}
    />
  )
}
